{
  "name": "@sol/catalog",
  "version": "1.0.0-SNAPSHOT",
  "dependencies": {
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@sol/components": "workspace:*",
    "@sol/icons": "workspace:*",
    "@sol/theme": "workspace:*",
    "chart.js": "^4.6.1",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.5",
    "rxjs": "~7.8.2",
    "tslib": "^2.9.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@asm/config": "workspace:1.0.0-SNAPSHOT",
    "@types/jasmine": "~6.0.0",
    "@typescript-eslint/parser": "^8.72.1",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.14.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.7",
    "jasmine-core": "~6.3.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "typescript": "~6.0.3"
  },
  "private": true,
  "scripts": {
    "ci:build:dit": "node ../asm-config/src/generate-configs.mjs && ng build --configuration dit",
    "ci:lint": "node ../asm-config/src/generate-configs.mjs && prettier --check src && eslint src --quiet",
    "ci:test": "node ../asm-config/src/generate-configs.mjs && ng test --watch=false",
    "lint": "node ../asm-config/src/generate-configs.mjs && prettier --write \"**/*.{ts,html,md,scss,json}\" && eslint src --fix --quiet",
    "ng": "node ../asm-config/src/generate-configs.mjs && ng",
    "start:dit": "node ../asm-config/src/generate-configs.mjs && ng serve --port 8084",
    "start:sandbox": "node ../asm-config/src/generate-configs.mjs && ng serve --port 8086 --configuration sandbox"
  }
}
